import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setError, setErrorReset } from '../../store/error.js';
import { HTTP_INTERNAL_ERROR } from '../../utils/constants.js';
import AuthLayout from '../layout/AuthLayout.jsx';

const BaseErrorFallback = ({ error, resetErrorBoundary }) => {
    const reset = useSelector((state) => state.error.reset);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setErrorReset({ reset: false, boundary: true }));
        dispatch(setError({ status: HTTP_INTERNAL_ERROR, statusText: error.message }));
    }, [dispatch, error.message]);

    useEffect(() => {
        if (reset) {
            dispatch(setErrorReset({ reset: false, boundary: false }));
            dispatch(setError({ status: false, statusText: null }));

            resetErrorBoundary();
        }
    }, [reset, dispatch, resetErrorBoundary]);

    return (
        <AuthLayout title='Error'>
            <div className='max-w-3xl w-full mx-auto px-4'>Error</div>
        </AuthLayout>
    );
};

export default BaseErrorFallback;
